import Icon from '@/Icon';

export type StatusType = 'SETUP' | 'OPEN' | 'BEFORE_LIVE' | 'LIVE' | 'DONE';
export type StatusType2 =
	| 'APPLY'
	| 'APPLY_REFUSED'
	| 'SETUP'
	| 'SETUP_COMPLETE'
	| 'UPCOMMING'
	| 'REGISTER'
	| 'QUALIFIER'
	| 'SELECTING'
	| 'PREMATCH'
	| 'MATCH'
	| 'EVALUATING'
	| 'INTERMISSION'
	| 'FINISHED'

	//
	// | "APPLY"
	// | "APPLY_REFUSED"
	// | "SETUP"
	// | "SETUP_COMPLETE"
	// | "UPCOMMING"
	| 'OPEN'
	| 'LIVE'
	// | "FINISHED"
	| 'NO_SHOW'
	| 'INCOMPLETE';

// fee 조건인데 로직 바뀜
export const feeStatus = ['SETUP', 'OPEN', 'BEFORE_LIVE'];

/** 리턴은 실제 api 메서드랑 동일하게 유지해야 함 */
export const rewardStatus = (isDiamond: boolean, status: StatusType | string) =>
	isDiamond ? (feeStatus.includes(status) ? 'realParticipationFee' : 'reward') : 'prize';

export const rewardStatusV2 = (isDiamond: boolean) => (isDiamond ? 'totalDiamond' : 'totalCash');

type Props = {
	status: StatusType | string;
	className?: string;
	width?: number | string;
	height?: number | string;
};

export const Status = ({ status, className, width, height }: Props) => {
	if (status === 'OPEN')
		return (
			<Icon
				className={className}
				path="Sticker_Status_Open"
				style={{
					height,
					width,
				}}
			/>
		);

	if (status === 'DONE')
		return (
			<Icon
				className={className}
				path="Sticker_Status_Done"
				style={{
					height,
					width,
				}}
			/>
		);
	if (status === 'LIVE')
		return (
			<Icon
				className={className}
				path="Sticker_Status_Live"
				style={{
					height,
					width,
				}}
			/>
		);
	if (status === 'BEFORE_LIVE')
		return (
			<Icon
				className={className}
				path="Sticker_Status_Live2"
				style={{
					height,
					width,
				}}
			/>
		);
	if (status === 'SETUP')
		return (
			<Icon
				className={className}
				path="Sticker_Status_Setup"
				style={{
					height,
					width,
				}}
			/>
		);

	return (
		<Icon
			className={className}
			path="Sticker_Status_Open"
			style={{
				height,
				width,
			}}
		/>
	);
};

/** 국제화로 대체 됨 */
// export const StatusText = (status: Props['status']) => {
// 	if (status === 'LIVE') return 'statusMessages.'
// 	if (status === 'OPEN') {
// 		return '$1 후에 시작됩니다'
// 	}
// 	if (status === 'DONE') return '종료된 토너먼트입니다.'
// 	if (status === 'SETUP') return '오픈해야 유저들이 참가할 수 있어요!'
// 	if (status === 'BEFORE_LIVE') {
// 		//
// 		return '$1 곧 시작해요. 준비하세요!'
// 	}
// 	return ''
// }

export const needTimeList = ['OPEN', 'BEFORE_LIVE'];
